<template>
  <el-card class="box-card user-card">
    <div class="content">
      <div class="container404">
        <h1>403</h1>
        <p>对不起，您尝试访问的页面目前对您不可用</p>
        <p>这可能是由于以下原因之一：</p>
        <ul>
          <li>您没有足够的权限来查看此页面。</li>
          <li>您的会话可能已过期，请尝试重新登录。</li>
          
        </ul>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      list: null,
      listLoading: true,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      console.info(this.$route.params);
    },
  },
};
</script>
<style lang="less">
.container404 {
  text-align: center;
  color: #333;

  h1 {
    font-size: 10rem;
    margin: 0;
    color: #e74c3c;
  }
  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }
  ul {
    margin: 0 auto;
    width: 300px;
    text-align: left;
    list-style: disc;
    padding-left: 20px;
  }
  a {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1rem;
    color: #fff;
    background-color: #3498db;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  a:hover {
    background-color: #2980b9;
  }
}
</style>
